import { getAxiosClient } from "../../axios-client";
import { EditStorageAreaRequestBody, EditStorageAreaResponse } from "./types";

const axiosClient = getAxiosClient();
export const editStorageArea = async (body: EditStorageAreaRequestBody) => {
  return await axiosClient.ax.put<EditStorageAreaResponse>(
    "StorageArea/Update",
    body
  );
};
